import styled from "styled-components";

export const NotificationWrapper = styled.div`
  /* background: var(--dashboard-primay); */
  /* box-shadow: 2px 6px 20px rgba(0, 0, 0, 0.15); */
  border-radius: 10px;
  min-width: 350px;
  max-width: 350px;
  max-height: 325px;
  overflow-y: scroll;
 
 ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background: #8b8b8b !important;
  border-radius: 6px !important;
}
  .item-card {
    background: var(--primary-bg);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 10px 10px 15px 10px;
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
  }

  .item-heading-container {
    display: flex;
    margin-left: 10px;
  }

  .item-title {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.5px;
    color: #575757;
  }
  .item-para {
    // font-family: "sans-serif";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.6px;
    color: var(--primary-text-color);
    cursor: pointer;
  }

  .item-time {
    // font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: right;
    letter-spacing: -0.078px;
    color: var(--secondary-text-color);
  }
`;

export const NotifyWrapper = styled.div`
  .ant-popover-inner {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color);
  }
`;
